export const service_id = 'service_nxv08fu'
export const template_id = 'template_4mjriz4'
export const public_key = 'LwBu1kSMnPSDQfHkB'